import React from 'react'
import { Descriptions, Modal} from 'antd';
import { LarpTOMCopyToClipboard } from '../multifunctional/LarpTomCopyToClickBoardButton';

export default function PaymentInfoModal({isModalVisible, setIsModalVisible, eventName, larperName}){

    function handleOk() {
        setIsModalVisible(false);
    }

    function handleCancel() {
        setIsModalVisible(false);
    }

    return (
            <Modal 
                title={`Payment information`}  
                visible={isModalVisible} 
                onOk={handleOk} 
                onCancel={handleCancel}
                footer={null}
                width={"80%"}
                
            >
                <Descriptions bordered column={1}>
                    <Descriptions.Item label="IBAN"> 
                        NL74 RBRB 0929 1308 55
                        <LarpTOMCopyToClipboard text='NL74 RBRB 0929 1308 55'/>
                    </Descriptions.Item>
                    <Descriptions.Item label="Rekeninghouder"> 
                        Tom Groenendaal
                        <LarpTOMCopyToClipboard text='Tom Groenendaal'/>
                    </Descriptions.Item>
                    <Descriptions.Item label="Betalingskenmerk"> 
                        {`${eventName} ${larperName}`}
                        <LarpTOMCopyToClipboard text={`${eventName} ${larperName}`}/>
                    </Descriptions.Item>
                </Descriptions>
            </Modal>
    )
}